"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetScheme = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var guMember_1 = require("../../model/guMember");
var service_1 = require("../../../library/base/service");
var GetScheme = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(GetScheme, _super);
    function GetScheme() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '积分商城小程序获取scheme';
        _this.code = '300008';
        _this.desc = '积分商城小程序获取scheme';
        _this.requestParams = new guMember_1.GetSchemeRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return GetScheme;
}(service_1.BaseService));
exports.GetScheme = GetScheme;
//# sourceMappingURL=getScheme.js.map